module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-filter-logic-block"
  }, [_c('div', {
    staticClass: "expression",
    class: _vm.definition.classes
  }, [(_vm.definition.isList) ? _c('label', [_vm._v(_vm._s(_vm.definition.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.expression.args), function(arg, argId) {
    return (_vm.definition.isList) ? _c('div', {
      staticClass: "arg"
    }, [(argId > 0) ? _c('select', {
      domProps: {
        "value": _vm.expression.type
      },
      on: {
        "change": _vm.setType
      }
    }, _vm._l((_vm.possibleOperators), function(operator) {
      return _c('option', {
        domProps: {
          "value": operator.name
        }
      }, [_vm._v(_vm._s(operator.title))])
    })) : _vm._e(), _vm._v(" "), _c('top-filter-logic-block', {
      attrs: {
        "expression": arg,
        "columns": _vm.columns,
        "parent": _vm.definition
      },
      on: {
        "update:expression": function($event) {
          _vm.setArg(argId, $event)
        },
        "delete": function($event) {
          _vm.deleteArg(argId)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.definition.isBinary) ? _c('span', {
    staticClass: "binaryArgs"
  }, [(_vm.definition.left == 'column') ? _c('SingleSelect', {
    attrs: {
      "value": _vm.expression.args[0],
      "options": _vm.columns,
      "display": function (c) { return _vm.translateColumn(c); }
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.expression.args, 0, $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('SingleSelect', {
    attrs: {
      "value": _vm.operatorObject(_vm.expression.type),
      "options": _vm.possibleOperators,
      "display": function (c) { return _vm.translateOperator(c); }
    },
    on: {
      "update:value": _vm.setType
    }
  }), _vm._v(" "), (_vm.definition.right == 'const' || _vm.definition.right == 'regex') ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expression.args[1]),
      expression: "expression.args[1]"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "v"
    },
    domProps: {
      "value": (_vm.expression.args[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expression.args, 1, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "v"
    }
  }, [_vm._v("Value")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.expression.args.length == 0) ? _c('select', {
    domProps: {
      "value": _vm.expression.type
    },
    on: {
      "change": _vm.setType
    }
  }, _vm._l((_vm.possibleOperators), function(operator) {
    return _c('option', {
      domProps: {
        "value": operator.name
      }
    }, [_vm._v(_vm._s(operator.title))])
  })) : _vm._e(), _vm._v(" "), (_vm.definition.isList) ? _c('button', {
    staticClass: "mdl-button add-button",
    on: {
      "click": _vm.addArg
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Add\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d14b38a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/query/TopFilterLogicBlock.vue
// module id = 468
// module chunks = 0